import { lazy, useState, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AuthPage from '../pages/Login';
import { cacheImLoginCredentials, type ImLoginCredentials } from '../imLoginCredentials';

const ChatComponent = lazy(() => import('../pages/ChatGithub'));

const IM_LOGIN_STORAGE_KEY = 'prjchat_im_login_v1';

function readStoredImLogin(): ImLoginCredentials | null {
  try {
    const raw = sessionStorage.getItem(IM_LOGIN_STORAGE_KEY);
    if (!raw) return null;
    const p = JSON.parse(raw) as Partial<ImLoginCredentials>;
    if (
      p &&
      typeof p.SDKAppID === 'number' &&
      Number.isFinite(p.SDKAppID) &&
      typeof p.userID === 'string' &&
      p.userID.length > 0 &&
      typeof p.userSig === 'string' &&
      p.userSig.length > 0
    ) {
      return {
        SDKAppID: p.SDKAppID,
        userID: p.userID,
        userSig: p.userSig,
      };
    }
  } catch {
    /* ignore corrupt storage */
  }
  return null;
}

function persistImLogin(credentials: ImLoginCredentials): void {
  try {
    sessionStorage.setItem(IM_LOGIN_STORAGE_KEY, JSON.stringify(credentials));
  } catch {
    /* quota / private mode */
  }
}

export default function AppRoutes() {
  const [imLogin, setImLogin] = useState<ImLoginCredentials | null>(() => {
    const restored = readStoredImLogin();
    if (restored) {
      cacheImLoginCredentials(restored);
    }
    return restored;
  });

  const handleLoginSuccess = (data: any) => {
    const credentials: ImLoginCredentials = {
      SDKAppID: Number(data.app_id),
      userID: String(data.user_id),
      userSig: String(data.userSig),
    };
    cacheImLoginCredentials(credentials);
    persistImLogin(credentials);
    if (data.nickname) {
      localStorage.setItem('user_nickname', data.nickname);
    }
    setImLogin(credentials);
  };

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route 
          path="/login" 
          element={
            imLogin 
              ? <Navigate to="/chat" replace /> 
              : <AuthPage onSuccess={handleLoginSuccess} />
          } 
        />
        <Route 
          path="/chat" 
          element={
            imLogin 
              ? (
                <ChatComponent
                  key={`${imLogin.SDKAppID}-${imLogin.userID}`}
                  {...imLogin}
                />
              )
              : <Navigate to="/login" replace />
          } 
        />
        {/* 默认跳转到登录页 */}
        <Route path="/" element={<Navigate to="/login" replace />} />
      </Routes>
    </Suspense>
  );
}
